import { GetState, SetState } from 'zustand';
import {
  COMPLETED,
  M_Error,
  M_Success,
  S_Tasks,
  TASK_M_COMPLETED,
  TASK_M_SETTED,
  TASK_M_UPDATED,
} from '../../common/Types';
import { updateByKey } from '../../firebase/refActions';
import { taskRef } from '../../firebase/refs';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import {
  getDailyTasks,
  getGoalTasks,
  removeTask,
} from '../actions/dailyTaskActions';
import { AppStatesI, TaskStatesI } from '../interfaces/storeStatesInterface';

export const createTaskStates = (
  _set: SetState<AppStatesI>,
  _get: GetState<AppStatesI>
): TaskStatesI => ({
  allTasks: [],
  dailyTasks: [],
  goalTasks: [],

  getDailyTasks: async (_date: Date) => getDailyTasks(_set, _get, _date),

  getGoalTasks: async (_goal_key: string) =>
    getGoalTasks(_set, _get, _goal_key),

  addDailyTasks: async (_tasks: DailyTaskI[]) => {
    try {
      _get().setLoading(true);
      _tasks.map(async (t) => {
        const newTask = taskRef.push();
        await newTask.set({ ...t, key: newTask.key });
      });
      _get().addMessage({
        type: M_Success,
        content: TASK_M_SETTED,
        stateName: S_Tasks,
      });
      _get().setLoading(false);
    } catch (error) {
      _get().addMessage({
        type: M_Error,
        content: error,
        stateName: S_Tasks,
      });
      _get().setLoading(false);
    }
  },
  updateTaskStatus: async (_task: DailyTaskI) => {
    try {
      if (!_task.key) throw new Error('Task key missing');
      _get().setLoading(true);

      updateByKey(taskRef, _task.key, _task, () => {
        _get().setLoading(false);
      });
    } catch (error) {
      _get().addMessage({
        type: M_Error,
        content: error,
        stateName: S_Tasks,
      });
      _get().setLoading(false);
    }
  },

  updateTask: async (_task: DailyTaskI) => {
    try {
      if (!_task.key) throw new Error('Task key missing');
      _get().setLoading(true);

      updateByKey(taskRef, _task.key, _task, () => {
        _get().addMessage({
          type: M_Success,
          content: TASK_M_UPDATED,
          stateName: S_Tasks,
        });
        _get().setLoading(false);
      });
    } catch (error) {
      _get().addMessage({
        type: M_Error,
        content: error,
        stateName: S_Tasks,
      });
      _get().setLoading(false);
    }
  },

  completedTask: async (_task: DailyTaskI) => {
    try {
      if (!_task.key) throw new Error('Task key missing');

      _get().setLoading(true);
      updateByKey(
        taskRef,
        _task.key,
        {
          ..._task,
          completedDate: new Date().toString(),
          taskStatus: COMPLETED,
        },
        () => {
          _get().addMessage({
            type: M_Success,
            content: TASK_M_COMPLETED,
            stateName: S_Tasks,
          });
          console.log('here');
          _get().setLoading(false);
        }
      );
    } catch (error) {
      _get().addMessage({
        type: M_Error,
        content: error,
        stateName: S_Tasks,
      });
      _get().setLoading(false);
    }
  },

  removeTask: async (_task: DailyTaskI) => removeTask(_set, _get, _task),
});
